import * as React from "react"
import { useTranslation } from "react-i18next"

export enum WarningTypes {
  License = 0,
  Region = 1,
  CustomerNotEligible = 2
}

export const WarningBanner = (props: { warningType: WarningTypes }) => {
  const selectMessage: string[] = [
    "licenseBanner.noLicenseMessage",
    "regionBanner.unsupportedRegionMessage",
    "eligibleBanner.customerNotEligibleMessage"
  ]
  const navigate = () => {
    window.open("https://quadri.trimble.com/buy", "_blank")?.focus()
  }

  const { t } = useTranslation("config")

  return (
    <div className="alert warning group my-2" role="alert">
      <div className="group-items">
        <span className="block flex-grow-1">{t(selectMessage[props.warningType])}</span>
        {props.warningType === WarningTypes.License ? (
          <button className="button cta small" onClick={navigate} title={t("licenseBanner.opensNewTab")}>
            {t("licenseBanner.buyLicense")}
          </button>
        ) : (
          <div style={{ height: 30 }} />
        )}
      </div>
    </div>
  )
}
